import { Routes, Route } from "react-router";
import WebinarListPage from "./list";
import WebinarHighlightsPage from "./highlights";
import NetworkingPage from "./networking";
import QaAssistantPage from "./qa-assistant";
import SimulcastPage from "./simulcast";
import VirtualBackgroundsPage from "./virtual-backgrounds";
import ControlRoomPage from "./control-room";
import EvergreenConfigPage from "./evergreen-config";
import CtaSequenceBuilderPage from "./offers";
import WebinarAnalyticsPage from "./analytics";
import WebinarReportPage from "./report";
import WebinarSurveysPage from "./surveys";
import SeriesManagementPage from "./series-management";
import { BreakoutRoomsManagementPage } from "./breakout-rooms";

/**
 * Webinar management module — list + per-webinar tool pages.
 *
 * Viewer pages (/webinar/:id/watch, /webinar/:id/backstage, etc.) are
 * wired separately in App.tsx outside the dashboard layout.
 */
export default function WebinarsPage() {
  return (
    <Routes>
      <Route index element={<WebinarListPage />} />
      <Route path="series" element={<SeriesManagementPage />} />
      <Route path="series/:seriesId" element={<SeriesManagementPage />} />
      <Route path=":webinarId/highlights" element={<WebinarHighlightsPage />} />
      <Route path=":webinarId/networking" element={<NetworkingPage />} />
      <Route path=":webinarId/qa" element={<QaAssistantPage />} />
      <Route path=":webinarId/simulcast" element={<SimulcastPage />} />
      <Route path=":webinarId/virtual-backgrounds" element={<VirtualBackgroundsPage />} />
      <Route path=":webinarId/control" element={<ControlRoomPage />} />
      <Route path=":webinarId/breakouts" element={<BreakoutRoomsManagementPage />} />
      <Route path=":webinarId/evergreen" element={<EvergreenConfigPage />} />
      <Route path=":webinarId/offers" element={<CtaSequenceBuilderPage />} />
      <Route path=":webinarId/analytics" element={<WebinarAnalyticsPage />} />
      <Route path=":webinarId/report" element={<WebinarReportPage />} />
      <Route path=":webinarId/surveys" element={<WebinarSurveysPage />} />
    </Routes>
  );
}
